// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HddOutlinedSvg from "@fishx/icons-svg/es/asn/HddOutlined";
import FishxIcon from '../components/FishxIcon';

var HddOutlined = function HddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HddOutlinedSvg
  }));
};

HddOutlined.displayName = 'HddOutlined';
export default React.forwardRef(HddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HddOutlined.js
// module id = 2914
// module chunks = 0